import React from "react";
import { AgGridReact } from "ag-grid-react";
import { Box } from "@mui/material";
import { Tooltip } from "antd";

import copyIcon from "../../../assets/images/newImages/copy-icon.svg";

import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";

import { InnerTableWrapper } from "./style";

import { copyToClip } from "../../../utils/utils";

const defaultColDef = {
  resizable: true,
  sortable: false,
  filter: false,
  suppressRowClickSelection: true,
  suppressMenu: true,
  suppressMovable: true,
};

const WorkRowDetails = (props) => {
  const { products_v2 } = props?.data || {};

  const columnDefs = [
    {
      headerName: "Mapped Product",
      minWidth: 135,
      flex: 1,
      field: "name",
      cellRenderer: ({ value }) => value || '---'
    },
    {
      headerName: "Identifier",
      minWidth: 100,
      flex: 1,
      cellRenderer: ({ data }) => {
        const { identifier_type, identifier_value } = data || {};

        return (
          <div className="identifier-text-wrapper">
            <p>{identifier_type || '---'}</p>
            <Box display="flex" alignItems="center" gap={1}>
              <span>{identifier_value || '---'}</span>
              <Tooltip title={'Click to Copy Identifier'}> <img src={copyIcon} alt="copyIcon" style={{ width: '12px', cursor: 'pointer', color: '#1565d8' }} onClick={() => copyToClip(identifier_value)} /></Tooltip>
            </Box>
          </div>
        )
      }
    },
    {
      headerName: "Brand",
      minWidth: 100,
      flex: 1,
      field: "brand",
      cellRenderer: ({ value }) => value || '---'
    },
    {
      headerName: "WH Stock",
      minWidth: 100,
      flex: 1,
      field: "warehouse_stock",
      cellRenderer: ({ value }) => value || 0
    },
    {
      headerName: "Pack Of",
      minWidth: 100,
      flex: 1,
      field: "product_sku_mappings_v2.bundle_quantity",
      cellRenderer: ({ value }) => value || 0
    },
    // {
    //   headerName: "Reserved Quantity",
    //   minWidth: 100,
    //   flex: 1,
    //   field: "reserved_qty",
    //   cellRenderer: ({ value }) => value || 0
    // },
  ];

  return (
    <InnerTableWrapper>
      <Box sx={{ maxHeight: 330, overflow: "auto" }}>
        <div className="ag-theme-alpine custom-grid-theme">
          <AgGridReact
            rowData={products_v2}
            rowHeight={40}
            defaultColDef={defaultColDef}
            columnDefs={columnDefs}
            headerHeight={36}
            domLayout="autoHeight"
            className="sku-details-table"
          />
        </div>
      </Box>
    </InnerTableWrapper>
  );
};

export default WorkRowDetails;
